import { render } from "./RolesListModal.vue?vue&type=template&id=42aeddb0"
import script from "./RolesListModal.vue?vue&type=script&lang=js"
export * from "./RolesListModal.vue?vue&type=script&lang=js"

import "./RolesListModal.vue?vue&type=style&index=0&id=42aeddb0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__